import { supabase } from '../config/supabase';

export const fetchExperiences = async () => {
    try {
        const { data, error } = await supabase
            .from('experiences')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            console.error("Error fetching experiences: ", error);
            return [];
        }

        return (data || []).map(exp => ({
            id: exp.id,
            name: exp.name,
            role: exp.role,
            date: exp.date,
            description: exp.description,
            type: exp.type,
            imageUrl: exp.image_url,
            darkImageUrl: exp.dark_image_url,
            createdAt: exp.created_at,
            roleEs: exp.role_es,
            dateEs: exp.date_es,
            descriptionEs: exp.description_es,
        }));
    } catch (error) {
        console.error("Error fetching experiences: ", error);
        return [];
    }
};

export const fetchProjects = async () => {
    try {
        const { data, error } = await supabase
            .from('projects')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            console.error("Error fetching projects: ", error);
            return [];
        }

        return (data || []).map(project => ({
            id: project.id,
            name: project.name,
            organization: project.organization,
            description: project.description,
            imageUrl: project.image_url,
            repositoryUrl: project.repository_url,
            techStack: project.tech_stack,
            createdAt: project.created_at,
            nameEs: project.name_es,
            descriptionEs: project.description_es,
            gradientKey: project.name,
        }));
    } catch (error) {
        console.error("Error fetching projects: ", error);
        return [];
    }
};

export const fetchTechStack = async () => {
    try {
        const { data, error } = await supabase
            .from('tech_stack')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            console.error("Error fetching tech stack: ", error);
            return [];
        }

        return (data || []).map(tech => ({
            id: tech.id,
            name: tech.name,
            icon: tech.icon_url,
            type: tech.type,
            createdAt: tech.created_at
        }));
    } catch (error) {
        console.error("Error fetching tech stack: ", error);
        return [];
    }
};

export const fetchSiteContent = async () => {
    try {
        const { data, error } = await supabase
            .from('site_content')
            .select('key, content_en, content_es');

        if (error) {
            console.error('Error fetching site content: ', error);
            return {};
        }

        return (data || []).reduce((acc, row) => {
            acc[row.key] = {
                en: row.content_en,
                es: row.content_es,
            };
            return acc;
        }, {});
    } catch (error) {
        console.error('Error fetching site content: ', error);
        return {};
    }
};
